import { GETv2Quote } from '@/api/quotes';

export const getForexList = async ({ queryKey }: { queryKey: string[] }) => {
  const column = queryKey[1];
  const type = queryKey[2];

  try {
    const res = await GETv2Quote({ column, type }, { next: { revalidate: 0 } });

    return res;
  } catch (e) {
    console.error(e);
    return [];
  }
};
